// 図鑑・建物図面の絵の大きさをそろえる表（tools/art/dex-fit.py で作る。手で直さない）。
// キー：絵のファイル、または戦闘のちび絵のシートと番号。s＝拡大率、x・y＝マスに対するずらし（割合）
export const DEX_FIT: Record<string, { s: number; x: number; y: number }> = {
  '/art/shiki/aooni-1.webp': { s: 0.891, x: -0.044, y: -0.002 },
  '/art/shiki/aooni-2.webp': { s: 0.877, x: -0.0, y: -0.0 },
  '/art/shiki/aooni-3.webp': { s: 0.889, x: -0.012, y: -0.006 },
  '/art/shiki/e008.webp': { s: 0.922, x: -0.0, y: -0.0 },
  '/art/shiki/e009.webp': { s: 1.009, x: -0.0, y: -0.0 },
  '/art/shiki/e010.webp': { s: 1.002, x: -0.0, y: -0.0 },
  '/art/shiki/e018.webp': { s: 0.96, x: -0.0, y: -0.0 },
  '/art/shiki/e019.webp': { s: 0.96, x: -0.0, y: -0.0 },
  '/art/shiki/e028.webp': { s: 1.012, x: 0.001, y: -0.0 },
  '/art/shiki/e029.webp': { s: 1.012, x: 0.001, y: 0.001 },
  '/art/shiki/e030.webp': { s: 1.009, x: -0.0, y: 0.001 },
  '/art/shiki/e038.webp': { s: 0.922, x: 0.001, y: -0.0 },
  '/art/shiki/e039.webp': { s: 0.922, x: -0.0, y: -0.0 },
  '/art/shiki/e040.webp': { s: 0.922, x: -0.0, y: -0.0 },
  '/art/shiki/e048.webp': { s: 0.922, x: -0.001, y: -0.0 },
  '/art/shiki/e049.webp': { s: 1.033, x: -0.008, y: -0.0 },
  '/art/shiki/e058.webp': { s: 1.012, x: -0.001, y: -0.0 },
  '/art/shiki/e059.webp': { s: 1.002, x: -0.001, y: -0.0 },
  '/art/shiki/e068.webp': { s: 0.922, x: -0.0, y: -0.0 },
  '/art/shiki/e069.webp': { s: 0.954, x: -0.0, y: -0.0 },
  '/art/shiki/e078.webp': { s: 0.927, x: -0.0, y: -0.0 },
  '/art/shiki/e079.webp': { s: 1.009, x: -0.0, y: -0.0 },
  '/art/shiki/e080.webp': { s: 0.969, x: -0.0, y: 0.001 },
  '/art/shiki/e088.webp': { s: 0.977, x: -0.0, y: -0.0 },
  '/art/shiki/e089.webp': { s: 0.924, x: -0.0, y: -0.001 },
  '/art/shiki/e098.webp': { s: 1.008, x: -0.0, y: -0.0 },
  '/art/shiki/e099.webp': { s: 0.943, x: -0.0, y: -0.0 },
  '/art/shiki/kokappa-1.webp': { s: 1.027, x: -0.02, y: -0.008 },
  '/art/shiki/kokappa-2.webp': { s: 0.977, x: -0.017, y: -0.025 },
  '/art/shiki/kokappa-3.webp': { s: 1.144, x: -0.012, y: 0.006 },
  '/art/shiki/konohatengu-1.webp': { s: 0.954, x: 0.01, y: -0.0 },
  '/art/shiki/konohatengu-2.webp': { s: 0.906, x: 0.013, y: 0.002 },
  '/art/shiki/konohatengu-3.webp': { s: 1.204, x: -0.006, y: -0.013 },
  '/art/shiki/kudagitsune-1.webp': { s: 1.25, x: -0.037, y: -0.016 },
  '/art/shiki/kudagitsune-2.webp': { s: 0.877, x: -0.023, y: 0.007 },
  '/art/shiki/kudagitsune-3.webp': { s: 0.98, x: -0.015, y: 0.017 },
  '/art/shiki/kyorinrin-1.webp': { s: 1.008, x: -0.026, y: -0.005 },
  '/art/shiki/kyorinrin-2.webp': { s: 1.031, x: -0.003, y: -0.017 },
  '/art/shiki/kyorinrin-3.webp': { s: 1.093, x: -0.003, y: 0.001 },
  '/art/shiki/mamedanuki-1.webp': { s: 0.966, x: -0.003, y: -0.003 },
  '/art/shiki/mamedanuki-2.webp': { s: 1.148, x: -0.007, y: -0.034 },
  '/art/shiki/mamedanuki-3.webp': { s: 1.008, x: -0.001, y: -0.008 },
  '/art/shiki/nue-1.webp': { s: 0.972, x: -0.014, y: -0.003 },
  '/art/shiki/nue-2.webp': { s: 0.884, x: -0.008, y: -0.006 },
  '/art/shiki/nue-3.webp': { s: 0.877, x: -0.013, y: 0.002 },
  '/art/shiki/nurikabe-1.webp': { s: 1.006, x: -0.001, y: -0.009 },
  '/art/shiki/nurikabe-2.webp': { s: 0.93, x: -0.0, y: 0.001 },
  '/art/shiki/nurikabe-3.webp': { s: 0.989, x: -0.03, y: -0.003 },
  '/art/shiki/onibi-1.webp': { s: 0.886, x: -0.012, y: 0.005 },
  '/art/shiki/onibi-2.webp': { s: 1.027, x: -0.013, y: -0.021 },
  '/art/shiki/onibi-3.webp': { s: 0.901, x: -0.007, y: -0.002 },
  '/art/shiki/r02.webp': { s: 0.932, x: -0.0, y: -0.0 },
  '/art/shiki/r05.webp': { s: 0.983, x: -0.0, y: -0.0 },
  '/art/shiki/r06.webp': { s: 0.954, x: -0.0, y: -0.0 },
  '/art/shiki/r07.webp': { s: 0.966, x: -0.0, y: -0.0 },
  '/art/shiki/r09.webp': { s: 0.98, x: -0.0, y: -0.001 },
  '/art/shiki/r10.webp': { s: 0.922, x: -0.0, y: -0.0 },
  '/art/shiki/yukinko-1.webp': { s: 0.867, x: -0.005, y: 0.002 },
  '/art/shiki/yukinko-2.webp': { s: 0.874, x: 0.002, y: 0.006 },
  '/art/shiki/yukinko-3.webp': { s: 0.943, x: -0.002, y: 0.007 },
  'buildings2:0': { s: 0.757, x: -0.01, y: -0.04 },
  'buildings2:1': { s: 0.788, x: -0.017, y: -0.072 },
  'buildings2:2': { s: 0.673, x: -0.012, y: -0.02 },
  'buildings:0': { s: 0.946, x: -0.002, y: -0.057 },
  'buildings:1': { s: 1.202, x: -0.056, y: -0.148 },
  'buildings:2': { s: 1.126, x: -0.035, y: -0.037 },
  'buildings:3': { s: 1.18, x: -0.002, y: -0.189 },
  'buildings:4': { s: 1.02, x: -0.028, y: 0.008 },
  'buildings:5': { s: 1.082, x: -0.055, y: 0.008 },
  'buildings:6': { s: 1.244, x: -0.002, y: 0.015 },
  'ch01:0': { s: 1.591, x: -0.0, y: -0.379 },
  'ch01:1': { s: 1.549, x: -0.0, y: -0.297 },
  'ch01:2': { s: 1.352, x: -0.003, y: -0.203 },
  'ch01:3': { s: 1.581, x: -0.003, y: -0.309 },
  'ch01:4': { s: 1.331, x: 0.003, y: -0.247 },
  'ch01:5': { s: 1.265, x: -0.002, y: -0.163 },
  'ch01:6': { s: 1.385, x: -0.0, y: -0.233 },
  'ch01:7': { s: 1.558, x: -0.0, y: -0.298 },
  'ch01:8': { s: 1.354, x: -0.0, y: -0.206 },
  'ch01:9': { s: 1.138, x: -0.002, y: -0.133 },
  'ch02:0': { s: 1.024, x: -0.002, y: -0.052 },
  'ch02:1': { s: 0.939, x: -0.002, y: -0.013 },
  'ch02:2': { s: 0.957, x: -0.0, y: -0.03 },
  'ch02:3': { s: 0.973, x: -0.008, y: -0.099 },
  'ch02:4': { s: 1.049, x: -0.0, y: -0.059 },
  'ch02:5': { s: 0.885, x: -0.0, y: 0.012 },
  'ch02:6': { s: 0.973, x: -0.008, y: -0.063 },
  'ch02:7': { s: 0.982, x: -0.002, y: -0.033 },
  'ch02:8': { s: 0.919, x: -0.002, y: -0.0 },
  'ch03:0': { s: 0.977, x: -0.002, y: -0.109 },
  'ch03:1': { s: 1.024, x: -0.0, y: -0.168 },
  'ch03:2': { s: 1.149, x: -0.002, y: -0.206 },
  'ch03:3': { s: 1.178, x: -0.0, y: -0.143 },
  'ch03:4': { s: 1.08, x: -0.0, y: -0.097 },
  'ch03:5': { s: 0.969, x: -0.002, y: -0.087 },
  'ch03:6': { s: 1.169, x: -0.002, y: -0.119 },
  'ch03:7': { s: 0.957, x: -0.0, y: -0.14 },
  'ch03:8': { s: 1.323, x: -0.0, y: -0.217 },
  'ch03:9': { s: 0.957, x: -0.0, y: -0.041 },
  'ch04:0': { s: 1.071, x: -0.0, y: -0.213 },
  'ch04:1': { s: 1.097, x: -0.0, y: -0.086 },
  'ch04:2': { s: 1.049, x: -0.0, y: -0.064 },
  'ch04:3': { s: 1.097, x: -0.0, y: -0.086 },
  'ch04:4': { s: 1.222, x: -0.0, y: -0.143 },
  'ch04:5': { s: 1.258, x: -0.0, y: -0.16 },
  'ch04:6': { s: 1.12, x: -0.0, y: -0.096 },
  'ch04:7': { s: 1.12, x: -0.002, y: -0.096 },
  'ch04:8': { s: 1.208, x: -0.0, y: -0.137 },
  'ch04:9': { s: 1.024, x: -0.0, y: -0.062 },
  'ch05:0': { s: 1.25, x: -0.0, y: -0.156 },
  'ch05:1': { s: 1.222, x: -0.0, y: -0.143 },
  'ch05:2': { s: 1.352, x: -0.0, y: -0.203 },
  'ch05:3': { s: 1.222, x: -0.0, y: -0.143 },
  'ch05:4': { s: 1.189, x: -0.0, y: -0.2 },
  'ch05:5': { s: 1.453, x: -0.003, y: -0.25 },
  'ch05:6': { s: 1.122, x: -0.0, y: -0.101 },
  'ch05:7': { s: 1.195, x: -0.002, y: -0.131 },
  'ch05:8': { s: 1.095, x: -0.002, y: -0.218 },
  'ch06:0': { s: 1.182, x: -0.002, y: -0.125 },
  'ch06:1': { s: 1.514, x: -0.003, y: -0.272 },
  'ch06:2': { s: 1.394, x: 0.003, y: -0.278 },
  'ch06:3': { s: 1.144, x: -0.0, y: -0.107 },
  'ch06:4': { s: 1.308, x: -0.0, y: -0.225 },
  'ch06:5': { s: 1.28, x: -0.0, y: -0.228 },
  'ch06:6': { s: 1.202, x: -0.0, y: -0.188 },
  'ch06:7': { s: 1.259, x: -0.002, y: -0.224 },
  'ch06:8': { s: 1.184, x: -0.002, y: -0.148 },
  'ch07:0': { s: 1.182, x: -0.0, y: -0.125 },
  'ch07:1': { s: 1.229, x: -0.0, y: -0.146 },
  'ch07:2': { s: 1.222, x: -0.0, y: -0.143 },
  'ch07:3': { s: 1.25, x: -0.002, y: -0.156 },
  'ch07:4': { s: 1.233, x: -0.002, y: -0.149 },
  'ch07:5': { s: 1.138, x: -0.0, y: -0.104 },
  'ch07:6': { s: 1.138, x: -0.002, y: -0.104 },
  'ch07:7': { s: 1.236, x: -0.002, y: -0.15 },
  'ch07:8': { s: 1.189, x: -0.0, y: -0.135 },
  'ch08:0': { s: 1.081, x: -0.0, y: -0.078 },
  'ch08:1': { s: 1.195, x: -0.0, y: -0.131 },
  'ch08:2': { s: 1.272, x: -0.002, y: -0.167 },
  'ch08:3': { s: 1.236, x: -0.002, y: -0.15 },
  'ch08:4': { s: 1.038, x: -0.002, y: -0.16 },
  'ch08:5': { s: 1.061, x: -0.0, y: -0.12 },
  'ch08:6': { s: 1.162, x: -0.0, y: -0.116 },
  'ch08:7': { s: 1.201, x: -0.0, y: -0.134 },
  'ch08:8': { s: 0.998, x: -0.0, y: -0.121 },
  'ch08:9': { s: 0.969, x: -0.002, y: -0.049 },
  'ch09:0': { s: 0.982, x: -0.0, y: -0.033 },
  'ch09:1': { s: 1.034, x: -0.0, y: -0.057 },
  'ch09:2': { s: 1.059, x: -0.0, y: -0.068 },
  'ch09:3': { s: 0.943, x: -0.0, y: -0.015 },
  'ch09:4': { s: 0.956, x: -0.002, y: -0.021 },
  'ch09:5': { s: 0.923, x: -0.002, y: -0.005 },
  'ch09:6': { s: 0.911, x: -0.0, y: -0.0 },
  'ch09:7': { s: 1.024, x: -0.002, y: -0.052 },
  'ch09:8': { s: 1.0, x: -0.002, y: -0.041 },
  'ch10:0': { s: 1.352, x: -0.0, y: -0.203 },
  'ch10:1': { s: 1.336, x: -0.003, y: -0.196 },
  'ch10:2': { s: 1.37, x: -0.0, y: -0.211 },
  'ch10:3': { s: 1.344, x: -0.0, y: -0.199 },
  'ch10:4': { s: 1.434, x: -0.003, y: -0.241 },
  'ch10:5': { s: 1.272, x: -0.002, y: -0.167 },
  'ch10:6': { s: 1.303, x: -0.003, y: -0.181 },
  'ch10:7': { s: 1.184, x: -0.002, y: -0.155 },
  'ch10:8': { s: 1.344, x: -0.003, y: -0.194 },
  'rivals:1': { s: 0.885, x: -0.0, y: 0.012 },
  'rivals:4': { s: 1.258, x: -0.0, y: -0.16 },
  'rivals:5': { s: 1.236, x: -0.005, y: -0.15 },
  'rivals:6': { s: 1.169, x: -0.0, y: -0.119 },
  'rivals:8': { s: 1.201, x: -0.002, y: -0.134 },
  'rivals:9': { s: 0.885, x: -0.0, y: 0.012 },
};
